import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import translationEN from './locales/en/translation.json';
import translationES from './locales/es/translation.json';
import translationRU from './locales/ru/translation.json';

const resources = {
    en: {
        translation: translationEN
    },
    es: {
        translation: translationES
    },
    ru: {
        translation: translationRU
    }
};

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources,
        fallbackLng: 'ru', // Default to Russian
        interpolation: {
            escapeValue: false // react already safes from xss
        },
        detection: {
            // Remove 'navigator' to prevent auto-detecting browser language (e.g. English)
            order: ['localStorage', 'cookie'],
            caches: ['localStorage']
        }
    });

export default i18n;
